import React from 'react';
import { createRoot } from 'react-dom/client';
import 'react-dates/initialize';
import { Provider } from 'react-redux';
import App from './Apps/App';
import store from './redux/store';
import './react-dates.css';
import './keyframes.css';
import * as Sentry from '@sentry/react';

const nodeEnv = process.env.NODE_ENV;

if (nodeEnv !== 'development') {
    Sentry.init({
        dsn: 'https://80f790f14dbae03851355a3ff6448840@o4509651973898240.ingest.us.sentry.io/4509651975405568',
        environment: process.env.NODE_ENV,
        // Setting this option to true will send default PII data to Sentry.
        // For example, automatic IP address collection on events
        sendDefaultPii: true,
        integrations: [
            Sentry.replayIntegration(),
            Sentry.replayCanvasIntegration(),
            Sentry.browserTracingIntegration(),
        ],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        tracesSampleRate: 1.0,
        tracePropagationTargets: [
            'localhost',
            'https://app.stage.current.tech',
            'https://app.current.tech/',
        ],
    });
}

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>,
);
